import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function WhatYouGet() {
  const items = ['Guía Paso a Paso: El Plan Maestro de 72 horas para detener el marcaje.', 'Protocolo de Limpieza Invisible: La fórmula exacta para borrar el rastro de orina para siempre.', 'Mapa de Ubicación N+1: Dónde poner las cajas para que no haya fallas.', 'Hack de Feromonas Casero: Cómo usar el "olor de paz" de tu gato a tu favor.', 'Checklist de Auditoría de Hogar: Identificá los disparadores de estrés en 5 minutos.'];
  return <section className="w-full bg-[#FAFAF7] py-6 md:py-20 px-4 md:px-6" data-id="element-447">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-448">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-6 md:mb-10 text-center" data-id="element-449">
          Qué recibís
        </h2>

        <div className="bg-white rounded-xl p-5 md:p-8 shadow-sm mb-6" data-id="element-450">
          <div className="space-y-4" data-id="element-451">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-452">
                <CheckCircle2Icon className="w-6 h-6 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-453" />
                <p className="text-[#1C1C1C] text-lg" data-id="element-454">{item}</p>
              </motion.div>)}
          </div>
        </div>

        <p className="text-center text-[#1C1C1C]/60 text-sm" data-id="element-455">
          Descarga inmediata. PDF. Sin suscripción.
        </p>
      </motion.div>
    </section>;
}